import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EApiCharacterType, EApiSubCharacterType } from '@datatype/iyagigo/api-type';

interface IState {
  currentAuthenticExpressionKey: string | null;
  currentStoryKey: string | null;
  currentGrammarStageKey: string | null;
  currentClassroomExpressionGroupKey: string | null;
  currentClassroomConversationGroupKey: string | null;
  characterType: EApiCharacterType;
  subCharacterType: EApiSubCharacterType;
  isStudying: boolean;
  // 자동 토스트(key 모드) "보러가기" 클릭 시 true → authentic-expression이 감지하여 비디오 자동 재생 후 false
  autoPlayAuthenticExpression: boolean;
}

const initialState: IState = {
  currentAuthenticExpressionKey: null,
  currentStoryKey: null,
  currentGrammarStageKey: null,
  currentClassroomExpressionGroupKey: null,
  currentClassroomConversationGroupKey: null,
  characterType: EApiCharacterType.HIRAGANA,
  subCharacterType: EApiSubCharacterType.SEION,
  isStudying: false,
  autoPlayAuthenticExpression: false,
};

const classroomSlice = createSlice({
  name: 'classroom',
  initialState,
  reducers: {
    initialize: (state) => {
      for (const key in state) {
        state[key] = initialState[key];
      }
    },
    storeCurrentAuthenticExpressionKey: (state, action: PayloadAction<string | null>) => {
      state.currentAuthenticExpressionKey = action.payload;
    },
    storeCurrentStoryKey: (state, action: PayloadAction<string | null>) => {
      state.currentStoryKey = action.payload;
    },
    storeCurrentGrammarStageKey: (state, action: PayloadAction<string | null>) => {
      state.currentGrammarStageKey = action.payload;
    },
    storeCurrentClassroomExpressionGroupKey: (state, action: PayloadAction<string | null>) => {
      state.currentClassroomExpressionGroupKey = action.payload;
    },
    storeCurrentClassroomConversationGroupKey: (state, action: PayloadAction<string | null>) => {
      state.currentClassroomConversationGroupKey = action.payload;
    },
    storeCharacterType: (state, action: PayloadAction<EApiCharacterType>) => {
      state.characterType = action.payload;
    },
    storeSubCharacterType: (state, action: PayloadAction<EApiSubCharacterType>) => {
      state.subCharacterType = action.payload;
    },
    storeIsStudying: (state, action: PayloadAction<boolean>) => {
      state.isStudying = action.payload;
    },
    storeAutoPlayAuthenticExpression: (state, action: PayloadAction<boolean>) => {
      state.autoPlayAuthenticExpression = action.payload;
    },
  },
});

export const actions = classroomSlice.actions;
export default classroomSlice.reducer;
